import { IconButton, ThemeProvider, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import React, { forwardRef, type FC } from 'react'
import { TooltipTheme } from './globalExports'
import './globalUtils.css'

export const ArrowProperties = {
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  direction: PropTypes.string.isRequired,
  rotateAngle: PropTypes.number,
  rotate: PropTypes.bool
}

type ArrowPropertiesPropTypes = PropTypes.InferProps<typeof ArrowProperties>

export const IconProperties = {
  iconClassName: PropTypes.string.isRequired,
  onIconClick: PropTypes.func,
  actionIcons: PropTypes.array,
  toolTipText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  containerClassName: PropTypes.string
}

type IconPropertiesPropTypes = PropTypes.InferProps<typeof IconProperties>

export const ActionIconsProperties = {
  actionIconsList: PropTypes.array,
  data: PropTypes.any
}

type ActionIconsPropertiesPropTypes = PropTypes.InferProps<
  typeof ActionIconsProperties
>

export const Arrow: FC<ArrowPropertiesPropTypes> = (props) => {
  const { color, onClick, direction, rotateAngle, rotate } = props

  const getClassName = (color: string, direction: string): string => {
    let cssClass: string = ''
    if (direction === 'down' && color === 'white') {
      cssClass = 'rms__down-white-arrow'
    } else if (direction === 'right' && color === 'white') {
      cssClass = 'rms__right-white-arrow'
    } else if (direction === 'up' && color === 'white') {
      cssClass = 'rms__right-up-arrow'
    } else if (direction === 'right' && color === 'black') {
      cssClass = 'rms__right-black-arrow'
    } else if (direction === 'down' && color === 'black') {
      cssClass = 'rms__down-black-arrow'
    }
    return cssClass
  }
  return (
    <div
      className={'rms__icon ' + getClassName(color, direction)}
      style={{
        transition: (rotate ?? false) ? 'transform 0.3s ease' : 'none',
        transform: `rotate(${rotateAngle}deg)`
      }}
      onClick={() => onClick?.()}
    ></div>
  )
}

export const Icon: FC<IconPropertiesPropTypes> = (props) => {
  const { iconClassName, onIconClick, containerClassName } = props
  return (
    <IconButton className={containerClassName + ' icon__button'} disableRipple={true} onClick={(event) => onIconClick?.(event)}>
      <div className={'rms__icon ' + iconClassName}></div>
    </IconButton>
  )
}

export const IconWithTooltip = forwardRef<HTMLDivElement, IconPropertiesPropTypes>(({ iconClassName, onIconClick, toolTipText, containerClassName }, ref) => {
  return (
    <ThemeProvider theme={TooltipTheme}>
      <Tooltip arrow title={toolTipText} sx={{cursor: 'pointer'}}>
        <div ref={ref} className={containerClassName ?? ''}>
          <Icon onIconClick={onIconClick} iconClassName={iconClassName}></Icon>
        </div>
      </Tooltip>
    </ThemeProvider>
  )
})

IconWithTooltip.displayName = 'IconWithTooltip'

export const ActionIcons: FC<ActionIconsPropertiesPropTypes> = (props) => {
  const { actionIconsList, data } = props

  const actionIconClassName = {
    pencilIcon: 'rms__pencil__icon',
    sheildIcon: 'rms__shield__icon',
    viewIcon: 'rms__view__icon',
    deleteIcon: 'rms__delete__icon',
    pencilWhiteIcon: 'rms__pencil__white__icon',
    settingsIcon:'rms__version__release__settings__icon'
  }

  return actionIconsList?.filter((actionIcon) => actionIcon?.isAccessible)?.map((actionElement, index) => {
    return (
      <IconButton
        disableRipple={true}
        onClick={(event) => actionElement?.action?.(event, data)}
        sx={{
          marginRight: ' 5px'
        }}
        key={actionElement?.icon + index}
        className='action__icon__btn'
      >
        <div
          className={'rms__icon ' + actionIconClassName[actionElement?.icon]}
        ></div>
      </IconButton>
    )
  })
}

const IconComponents = {
  Arrow,
  Icon,
  ActionIcons,
  IconWithTooltip
}

export default IconComponents
